<template>
  <div v-if="this.$store.state.ResetrouterNavWidth!=0">
       <div class="left-div"  :style='{width:(this.$store.state.ResetrouterNavWidth)+"px"}'>
          <div class="common-space-between common-items-center nameNav">
            <span>设备分类</span>
          </div>
          <div class="warp" :style='{height:(this.$store.state.windowHeight-200)+"px"}'>
              <el-collapse v-model="activeNames">
                  <template v-for="(item,index) in listType">
                    <el-collapse-item v-if="!!item.children"  :key="index" :title="item.name" :name='index'>
                       <div class="btn" :class='[item.id+items.id==val ? "active":""]' v-for="(items,indexs) in item.children" :key="indexs"  @click="selectBtn(items)">{{items.name}}</div>
                    </el-collapse-item>
                  </template>
              </el-collapse>
          </div>
       </div>
  </div>
</template>
<script>
  import {isEmpty} from '@/utils/util'
  import {getFun } from '@/utils/httpFun';
  import {userApi} from '@/utils/config'
  export default{
    data:()=>({
        activeNames: [0],
        listType:[],
        val:0,
    }),
    created(){
      
    },
    mounted(){
      this.getEQdata()
    },
    methods:{
        //获取设备分类
        async getEQdata(){
          await getFun(userApi.FACTROYDEVETYP,{},res=>{
            this.listType = res.data
            this.$parent.searchBtn(res.data[0].children[0])
            this.val = res.data[0].children[0].id*1+res.data[0].children[0].parentId
          })
        },
        
        //选中的值
        selectBtn(ev){
           this.val = ev.id*1+ev.parentId*1
           this.$parent.searchBtn(ev)
        }
    }
  }
</script>
<style lang="scss" scoped>
   .left-div{
         box-sizing: border-box;
        .nameNav{
            height: 56px;
            width: 100%;
            padding: 0 15px;
            background-color: #FFFFFF;
            border-bottom: 1px solid rgba(205, 216, 233, 0.19);
            box-sizing: border-box;
            overflow: hidden;
            font-size: 14px;
            color: #4D5C72;
            padding-top: 10px;
        }
        .warp{
           padding: 15px;
           box-sizing: border-box;
           overflow-y: auto;
           ::v-deep .el-collapse{
              border-top: 0;
           }
           ::v-deep .el-collapse-item{
              // margin-bottom: 10px;
              .el-collapse-item__header{
                  // background-color: rgba(24, 115, 255, 0.1);
                  height: 42px;
                  // padding: 0 10px;
                  box-sizing: border-box;
                  border: 0;
                  font-weight: 700;
              }
              .el-collapse-item__wrap{
                  border-bottom:0
              }
           }
           ::v-deep .el-collapse-item__content{
                 padding-bottom: 0;
                 padding-top: 10px;
           }
          .btn{
             width: 100%;
             height: 36px;
             background-color: rgba(180, 180, 180, 0.05);
             border-radius: 6px;
             line-height: 36px;
             padding: 0 10px;
             box-sizing: border-box;
             margin-bottom: 10px;
             font-size: 12px;
             cursor: pointer;
          }
          .btn.active{
             background-color: rgba(24, 115, 255, 0.06)
          }  
          
        }
  }
</style>